<script setup lang="ts" name="ErrorServer">
import ServerErrorCard from '~/components/ServerErrorCard.vue';
</script>

<template>
  <div class="mt-48">
    <ServerErrorCard />
  </div>
</template>
